<template>
  <div class="page" ref="container">
    <nav-bar
      title="我的顾问"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="false"
      :placeholder="true"
    />
    <cell-group title="基本信息">
      <cell title="姓名" :value="info.trueName" />
      <cell title="昵称" :value="info.nickname" v-if="info.nickname" />
      <cell title="电话" :value="info.phone" />
      <cell title="性别" :value="info.sex == 0 ? '女' : '男'" v-if="info.sex" />
    </cell-group>
  </div>
</template>
<script>
import { NavBar, Cell, CellGroup } from "vant";
import { getAdviser } from "@api/member";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  components: {
    Cell,
    CellGroup,
    NavBar,
  },
  props: {},
  data: function () {
    return {
      info: {},
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.init();
      },
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    init: function () {
      if (this.userInfo.waiterId) {
        getAdviser(this.userInfo.waiterId).then((res) => {
          this.info = res.result;
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
}
</style>
